import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const TOKEN_KEY = "s369.vault.token";

export const authHeaders = () => ({ Authorization: `Bearer ${sessionStorage.getItem(TOKEN_KEY) || ""}` });

export function errText(e) {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg).filter(Boolean).join(" ");
  return "Something went wrong. Try again.";
}

export const api = axios;
